import React from 'react'

export const useMutationObserver = (
  ref: React.RefObject<any>,
  callback: (r: MutationRecord[]) => void,
  // eslint-disable-next-line no-undef
  options: MutationObserverInit
) => {
  React.useEffect(() => {
    if (ref.current) {
      const observer = new MutationObserver(callback)
      observer.observe(ref.current, options)
      return () => observer.disconnect()
    }
  }, [callback, options])
}
